<nz-modal
  [nzVisible]="true"
  [nzFooter]="null"
  [nzTitle]="i18n.langString('exit')"
  (nzOnCancel)="closeEvent.emit(false)"
  [nzCloseIcon]="closeIcon"
  [nzContent]="modalContent"
  [nzMaskClosable]="false"
>
  <ng-template #closeIcon>
    <img alt="closeTab" src="assets/icons/exit_new.svg" />
  </ng-template>

  <ng-template #modalContent>
    <div class="card-layer" [class.mobile]="isMobile()">
      @if (exitBuildingAreaSetup()) {
        <h1>{{ i18n.langString("do_exit_areabuildingsetup") }}</h1>
      } @else {
        <h1>{{ i18n.langString("do_exit") }}</h1>
      }

      @if (false && exitBuildingAreaSetup()) {
        <span class="regular black-coral-text">
          {{ i18n.langString("do_exit_hint_areabuildingsetup") }}
        </span>
      } @else {
        <span>{{ i18n.langString("do_exit_hint") }}</span>
      }

      <div class="buttonwrapper">
        <app-nav-button
          [darksecondary]="true"
          [whiteBG]="true"
          (clickEvent)="closeEvent.emit(false)"
        >
          {{ i18n.langString("no_stay") }}
        </app-nav-button>

        <app-nav-button [primary]="true" (clickEvent)="closeEvent.emit(true)">
          {{ i18n.langString("yes_exit") }}
        </app-nav-button>
      </div>
    </div>
  </ng-template>
</nz-modal>
